<div class="delete-account-component-root">
  <app-epson-logo></app-epson-logo>
  <app-header>{{text.deleteYourAccount}}</app-header>
  <app-paragraph>{{text.deleteAccountInfo}}</app-paragraph>
  <app-input id="email-address-input"
             [label]="text.emailAddress"
             [control]="emailAddressControl"
             [autocomplete]="false"></app-input>
  <app-input id="password-input"
             [label]="text.password"
             [control]="passwordControl"
             type="password"
             [autocomplete]="false"></app-input>
  <div class="forgot-password">
    <app-anchor id="forgot-password-click"
                class="forgot-password-click"
                [routerLink]="'/'+RoutesKeys.FORGOT_PASSWORD"
                thin>
      {{text.forgotPassword}}
    </app-anchor>
  </div>
  <div class="button-group">
    <app-primary-button id="delete-account-click"
                        class="delete-account-click"
                        (clickAction)="openDeleteAccountDialog()"
                        [abstractControl]="formGroup">
      {{deleteAccountButtonText()}}
    </app-primary-button>
    <app-primary-button id="cancel-click"
                        [routerLink]="'/'+RoutesKeys.ACCOUNT_SETTINGS">
      {{text.changedMyMind}}
    </app-primary-button>
  </div>
</div>
